module.exports = __webpack_public_path__ + "media/images/help/about/icon-reason-4-886d4c3ec58f14113ade5c6ee44848aa.svg";